module.exports = __webpack_public_path__ + "static/media/id.cc80e181.png";